import React from 'react'
import classNames from 'classnames'
import classes from './CardProgress.module.css'
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check.svg'

export const CardProgressVariants = Object.freeze({
    teal: classes.teal,
    paleBlue: classes.paleBlue,
})

export const CardProgress = ({
    value = 0,
    max = 100,
    showLabel = false,
    variant = CardProgressVariants.teal,
    className,
    ...props
}) => {
    const percentage = Math.ceil((value / max) * 100)
    const completed = value === max || percentage === 100
    return (
        <div
            className={classNames(
                classes.cardProgress,
                variant,
                completed && classes.cardProgressCompleted,
                className
            )}
            {...props}
        >
            <progress
                value={value}
                max={max}
                className={classes.progress}
            ></progress>
            {showLabel && !completed && (
                <span className={classes.label}>{percentage}%</span>
            )}
            {completed && (
                <>
                    <span className={classes.completedText}>Completed</span>
                    <CheckIcon className={classes.completedIcon} />
                </>
            )}
        </div>
    )
}
